module.exports = __webpack_public_path__ + "img/Eleven_Tickets_Negativo_Horizontal.4016ae72.svg";